// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payment-upload-excel-file .el-upload-dragger{\n  width: 300px;\n  height: 130px;\n}\n.payment-upload-excel-file .el-icon-upload{\n    font-size: 34px;\n    color: #D3D7DF;\n    margin: 28px 0 16px;\n    line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
